module.exports = __webpack_public_path__ + "static/tpp-image09-01475c7918fcfbe126eaacba6a684a3e.jpg";